import type { FiltersState } from '../types';

export const DEFAULT_FILTERS: FiltersState = {
  ticker: '',
  recommendation_type: '',
  sort_by: 'last_updated',
  limit: 20,
  has_trade: false
};

export function getFiltersFromSearch(search: string): FiltersState {
  const params = new URLSearchParams(search);
  const limitParam = params.get('limit');
  const limit = limitParam ? Math.min(100, Math.max(1, parseInt(limitParam, 10) || 20)) : 20;
  const hasTradeParam = params.get('has_trade');
  const has_trade = hasTradeParam === '1' || hasTradeParam === 'true';
  return {
    ticker: (params.get('ticker') ?? '').trim().toUpperCase() || '',
    recommendation_type: (params.get('recommendation_type') ?? '').toUpperCase() || '',
    sort_by: params.get('sort_by') === 'filing_date' ? 'filing_date' : 'last_updated',
    limit: Number.isFinite(limit) ? limit : 20,
    has_trade
  };
}

export function filtersToSearch(filters: FiltersState): string {
  const params = new URLSearchParams();
  if (filters.ticker) params.set('ticker', filters.ticker);
  if (filters.recommendation_type) params.set('recommendation_type', filters.recommendation_type);
  if (filters.sort_by !== DEFAULT_FILTERS.sort_by) params.set('sort_by', filters.sort_by);
  if (filters.limit !== DEFAULT_FILTERS.limit) params.set('limit', String(filters.limit));
  if (filters.has_trade) params.set('has_trade', '1');
  return params.toString();
}
